import { extra } from '@/theme/colors/palettes';
import { HStack, Text } from '@chakra-ui/react';
import { MIN_SEGMENT_PX } from './helpers';

interface Props {
  color: string;
  grow: number;
  value: number;
}

const BarSegment = ({ color, grow, value }: Props) => {
  if (grow <= 0 || value <= 0) return null;

  return (
    <HStack
      backgroundColor={color}
      height={'100%'}
      flexGrow={grow}
      flexShrink={0}
      flexBasis={0}
      minWidth={`${MIN_SEGMENT_PX}px`}
      paddingX={'6px'}
      justifyContent={'flex-end'}
      alignItems={'center'}
    >
      <Text variant={'urbanistSmallBold'} color={extra.white} fontWeight={700}>
        {value}
      </Text>
    </HStack>
  );
};

export default BarSegment;
